module.exports = __webpack_public_path__ + "static/media/49.9780b8bd.jpg";